// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OrderDetails_wrap__3KCUS","container":"OrderDetails_container__12K_e"};